<template>
  <el-dialog :title="title"
             :visible.sync="dialogFormVisible"
             custom-class="list-dialog"
             center
             :close-on-click-modal="false" :show-close="true"
             :append-to-body="true"
             :modal="true">
    <div class="search-content">
      <el-col :span="24" class="toobar">
        <el-col :span="6">
          <el-select class="Select" v-model="cangkucode" placeholder="请选择仓库" style="width:130px">
            <el-option v-for="item in jxcstoreData" :key="item.cangkucode"
                       :label="item.cangkuname"
                       :value="item.cangkucode">
            </el-option>
          </el-select>
          <CommonTree ref="treeSeed" :defineDataSource="true" @bindData="bindTree" :isShowCheckBox="false"
                      :treeHeight="400" :treeWidth="400" :searchText="seedname" :canDelete="false"
                      style="width:200px;display: inline-block;" @check="checktree"></CommonTree>
          <el-date-picker
            v-model="minyear" @change="changeyear"
            type="year"
            style="width: 100px"
            placeholder="选择年">
          </el-date-picker>
        </el-col>
        <el-col :span="11">
          <el-checkbox-group v-model="monthflag" style="display: inline-block;">
            <el-checkbox-button v-for="item in items" :label="item" :key="item"
                                @change="choosemonth($event,item)">{{item}}月
            </el-checkbox-button>
          </el-checkbox-group>
        </el-col>
        <el-input v-model="xishu" placeholder="请输入系数" style="width:110px" clearable @clear="xishuclear"></el-input>
        <el-button type="primary" round @click="jisuanstock">计算
        </el-button> <el-button type="primary" round @click="loadexcel">导出
      </el-button><br>
        <el-button type="success" round plain @click="saveData('最大库存')" style="float: right"
                   :disabled="number<=0">生成最大库存
        </el-button>
        <el-button type="success" round plain @click="saveData('最小库存')" style="float: right"
                   :disabled="number<=0">生成最小库存
        </el-button>
      </el-col>
    </div>
    <el-col :span="24">
      <el-col :span="21">
        <div v-if="showerweitable&&filltemplate!=40" ref="print1">
          <TwoDimensionalTable ref="referweibiao" :isShowTotalNumber="true" :erweitable="erweitable" @num="totalnumber"></TwoDimensionalTable>
        </div>
        <div v-if="showzuoyoutable&&filltemplate!=40" ref="print1">
          <el-col :span="2" style="text-align: left">右眼：</el-col>
          <el-col :span="6">
            <TwoDimensionalTable ref="referweibiaoright" :isShowTotalNumber="true" :erweitable="erweitableright" :cutHeight="100" @num="totalnumber"></TwoDimensionalTable>
          </el-col>
          <el-col :span="2" style="text-align: left">左眼：</el-col>
          <el-col :span="6">
            <TwoDimensionalTable ref="referweibiaoleft" :isShowTotalNumber="true" :erweitable="erweitableleft" :cutHeight="100" @num="totalnumber"></TwoDimensionalTable>
          </el-col>
        </div>
      </el-col>
    </el-col>
  </el-dialog>
</template>

<script>
  import {getStoreFormList, getGoodsListWithStoreDetail} from '@/api/set/jxcresultstore';
  import {cusandptbyind} from '@/api/set/jxcstore';
  import {getGoodsTree} from '@/api/set/jxcgooddetail';
  import TwoDimensionalTable from '@/components/set/goodsprice/TwoDimensionalTable';
  import {getPrice} from '@/api/set/goodsprice';
  import {saveData} from '@/api/set/jxcstorelimit';

  export default {
    name: "zhinengstock",
    data() {
      return {
        costpricebook: {},
        title: '智能库存',
        items: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
        dialogFormVisible: false,
        monthvalue: [],
        initContent: [],
        initContentLeft: [],
        initContentRight: [],
        erweitable: [],//二维表
        erweitableleft: [],
        erweitableright: [],
        minyear: '',//年
        month: '',//月
        xishu: '',//系数
        seedcode: '',//商品编码
        seedname: '',
        cangkucode: '',//仓库编码
        filltemplate: '',//
        minstorebook: '',//最小库存设置
        mzxstorebook: '',//最大库存设置
        jxcstoreData: [],//仓库
        tableData: [],
        tableData2: [],
        tableStoreDetail: [],
        showzuoyoutable: false,
        showerweitable: false,
        erpserials: "",//销售单明细
        monthflag: [],//月份
        number: 0,
        form: {  //表单数据
          seedcode: "",
          minstorebook: "",
          maxstorebook: "",
          cangkucode: "",
          enabled: 1,
          filltemplate: ""
        },
      }
    },
    methods: {
      xishuclear() {
        if (!this.xishu || this.xishu == '') {
          if (this.filltemplate == "30") {
            this.initContentLeft = []
            this.initContentRight = []
            this.createPriceBookzy()
          } else {
            this.initContent = []
            this.createPriceBook()
          }
        }
      },
      totalnumber(num) {
        this.number = num
      },
      loadexcel(){//导出二维表
        this.$refs.referweibiao.getExcel();
      },
      //计算库存
      jisuanstock() {
        if (this.monthflag.length == 0) {
          this.$message.error("请先选择月份");
          return
        }
        if (!this.xishu || this.xishu == '') {
          this.tableData = []
          this.tableData = JSON.parse(JSON.stringify(this.tableData2))
          this.$message.error("请输入系数");
          return
        }

        var reg = /^\d+$|^\d*\.\d+$/g;
        if (!reg.test(this.xishu)) {
          this.xishu = ''
          this.$message.error('请输入有效数字！');
          return
        }
        if (this.xishu == 0) {
          this.xishu = ''
          this.$message.error('请输入大于0的系数！');
          return
        }
        this.churu();//合计选中得月份

        for (let j in this.tableData) {
          this.tableData[j].hassale = parseFloat(this.tableData[j].hassale) * parseFloat(this.xishu) / parseFloat(this.monthflag.length);
        }

        this.$nextTick(() => {
          this.bindTwoDimens()
        })
      },
      changeyear(event) {
        this.monthflag = []
      },
      //月份选择
      choosemonth(event, month) {
        var year = new Date(this.minyear).getFullYear();

        this.xishu = ''
        this.month = month
        //this.tableData = JSON.parse(JSON.stringify(this.tableData2))
        for (let i in this.monthvalue) {
          if (this.monthvalue[i].month == (year + '-' + month))//已经获取过
          {
            return;
          }
        }

        //出入库明细
        getStoreFormList({
          seedcode: this.seedcode,//产品分类（单选）
          cangkucode: this.cangkucode,//选择的仓库（单选）
          minyear: year,
          minmonth: this.month,
          maxyear: year,
          maxmonth: this.month,
          nostock: 1,
        }).then(response => {
          if (response.data.code == 0) {
            this.tableStoreDetail = response.data.obj;
            this.monthvalue.push({month: year + '-' + this.month, value: response.data.obj});
          }
        });
      },
      churu() {
        this.tableData = [];
        var year = new Date(this.minyear).getFullYear();
        for (var i in this.monthflag) {
          var month = this.monthflag[i]
          var item = {};
          for (let j in this.monthvalue) {
            if (this.monthvalue[j].month.toString() == (year + '-' + month.toString())) {
              item = this.monthvalue[j];
            }
          }

          for (let j in item.value) {
            if (item.value[j].creditnum && parseInt(item.value[j].creditnum) > 0 &&
              (item.value[j].ordername == '销货单' || item.value[j].ordername == '调拨出库')
            ) {
              var falage = true
              for (let t in  this.tableData) {
                if (item.value[j].packagesize == this.tableData[t].packagesize) {
                  falage = false
                  this.tableData[t].hassale += item.value[j].creditnum;
                  continue;
                }
              }
              if (falage) {
                var obj = {}
                obj.packagesize = item.value[j].packagesize
                obj.hassale = item.value[j].creditnum
                this.tableData.push(obj)
              }
            }
          }
        }
      },
      show(obj) {
        this.init()
        this.filltemplate = obj.filltemplate
        this.seedcode = obj.seedcode
        this.seedname = obj.seedname
        this.cangkucode = obj.cangkucode
        this.dialogFormVisible = true;
        this.controlerweitableview()
        //判断是否有成本价
        this.getXYRange()
      },
      //初始化
      init() {
        //年份
        this.minyear = new Date()
        this.xishu = ''
        this.seedname = ''
        this.seedcode = ''
        this.monthvalue = []
        this.initContent = []
        this.initContentLeft = []
        this.initContentRight = []
        this.filltemplate = ''
        this.tableData = []
        this.tableData2 = []
        this.tableStoreDetail = []
        this.monthflag = []
        for (let i in this.form) {
          if (i == 'enabled') {
            this.form[i] = 1
          } else
            this.form[i] = ''
        }
      },
      bindTree() {//绑定树控件
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({nostock: 1})
        })
      },
      checktree(guids, names, arr) {
        this.seedcode = guids
        this.seedname = names
        this.showzuoyoutable = false
        this.showerweitable = false
        this.filltemplate = arr[0].attributes.filltemplate
        this.controlerweitableview()
        if (this.$refs.referweibiao) {
          this.$refs.referweibiao.initForm()
        }
        if (this.$refs.referweibiaoleft) {
          this.$refs.referweibiaoleft.initForm()
        }
        if (this.$refs.referweibiaoright) {
          this.$refs.referweibiaoright.initForm()
        }
        if (this.form.seedname == "") {
          return
        }
        //判断是否有成本价
        this.getXYRange()
      },
      getXYRange() {
        getPrice({seedcode: this.seedcode, filterType: "cost", notneedconnectprice: true}).then((response) => {
          if (response.data.code == 0 && response.data.obj) {
            this.costpricebook = response.data.obj
          } else {
            this.costpricebook = {}
          }

          if (this.filltemplate == 30) {
            this.createPriceBookzy();
          } else {
            this.createPriceBook()
          }

        })

      },
      controlerweitableview() {//控制左右眼二维表
        if (this.filltemplate == '30') {//左右眼
          this.showzuoyoutable = true
          this.showerweitable = false
        } else {
          this.showzuoyoutable = false
          this.showerweitable = true
        }

      },
      bindTwoDimens() {
        this.initContent = []
        this.initContentLeft = []
        this.initContentRight = []
        for (let j in this.tableData) {
          if (this.tableData[j].packagesize && this.tableData[j].packagesize != '') {
            var ps = JSON.parse(this.tableData[j].packagesize);
            var P = Math.ceil(this.tableData[j].hassale);
            if (!P || P == 0) {
              P = ''
            }
            ps.P = P
            if (this.filltemplate == "30") {//左右眼
              if (ps.type == "L")
                this.initContentLeft.push(ps)
              else
                this.initContentRight.push(ps)
            } else {
              this.initContent.push(ps);
            }
          }
        }
        this.$nextTick(() => {
          if (this.filltemplate == "30") {
            this.createPriceBookzy()
          } else {
            this.createPriceBook()
          }
        })
      },
      createPriceBook(defaultprice) {
        if (this.$refs.referweibiao) {
          this.$refs.referweibiao.initBook(this.costpricebook, this.initContent, defaultprice || "")
        }
      },
      createPriceBookzy(defaultprice) {//区分左右眼的二维表
        if (this.$refs.referweibiaoleft)
          this.$refs.referweibiaoleft.initBook(this.costpricebook, this.initContentLeft, defaultprice || "")
        if (this.$refs.referweibiaoright)
          this.$refs.referweibiaoright.initBook(this.costpricebook, this.initContentRight, defaultprice || "")
      },
      saveData(title) {
        this.$confirm('此操作将生成' + title + ', 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.gongyong(title)
          this.form.seedcode = this.seedcode
          this.form.filltemplate = this.filltemplate
          this.form.cangkucode = this.cangkucode
          if (title == '最大库存') {
            if (!this.form.maxstorebook || this.form.maxstorebook == '') {
              this.$message.error("请先选择月份或输入系数且数据不可为“0”！");
              return
            }
          } else {
            if (!this.form.minstorebook || this.form.minstorebook == '') {
              this.$message.error("请先选择月份或输入系数且数据不可为“0”！");
              return
            }
          }
          saveData(this.form).then(response => {
            this.$message({
              message: '保存成功',
              type: 'success'
            })
            this.$emit("afterSet");
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      },
      gongyong(title) {
        var arr = [];
        var arrleft = [];
        var arrrigth = [];
        if (this.filltemplate == "30") {
          for (let i in   this.erweitableleft) {
            let temp = this.erweitableleft[i].filter((t) => {

              return typeof(t.P) != "undefined" && t.P !== ""
            })
            arrleft = arrleft.concat(temp)
          }
          arrleft = this.getFormat(arrleft)
          for (let i in  arrleft) {
            arrleft[i]["type"] = "L"
          }

          for (let i in   this.erweitableright) {
            let temp = this.erweitableright[i].filter((t) => {
              return typeof(t.P) != "undefined" && t.P !== ""
            })
            arrrigth = arrrigth.concat(temp)
          }

          arrrigth = this.getFormat(arrrigth)

          for (let i in  arrrigth) {
            arrrigth[i]["type"] = "R"
          }
          arr = arrrigth.concat(arrleft)

        } else {
          for (let i in   this.erweitable) {
            let temp = this.erweitable[i].filter((t) => {
              return typeof(t.P) != "undefined" && t.P !== ""
            })
            arr = arr.concat(temp)
          }
          // arr = this.getFormat(arr)//未填写的数量赋0
        }
        if (title == "最小库存") {
          this.form.maxstorebook = null;
          this.form.minstorebook = JSON.stringify(arr);
        } else {
          this.form.minstorebook = null;
          this.form.maxstorebook = JSON.stringify(arr);
        }
      },
      getFormat(data) {
        var table = []
        this.costpricebook.BookContent.forEach(o => {
          let temp = data.filter(item => {
            return item.X == o.X && item.Y == o.Y
          })
          if (temp.length > 0) {
            o.P = temp[0].P
          }
          else {
            o.P = 0
          }
          table.push(Object.assign({}, o))
        })
        return table
      },
    },
    mounted() {
      //仓库
      cusandptbyind({}).then(response => {
        this.jxcstoreData = response.data.obj
      })

    },
    components: {
      TwoDimensionalTable
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/testorder/warehouse/zhinengstock.vue